import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectBMHistoryResponseMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.BM_HISTORY_RESPONSE);
        this.HistoricalBMs = null;
    }
}
